import request from "@/axios/index.js";
function getParameter(data) {
  var parameter = '?'
  for (var item in data) {
      parameter = parameter + item + '=' + data[item] + '&'
  }
  parameter=parameter.substring(0,parameter.length-1)
  return parameter
}

//注册
// export function register(data){
//   return request(
//     {
//       url:'/api/register',
//       method:'post',
//       data
//     }
//   )
// }

//登录
export function login(data){
  return request({
    url:'/api/login',
    method:'post',
    data
  })
}
//获取菜单
export function getUrl(){
  return request(
    {
      url:"/api/jump/getUrl",
      method:'post'
    }
  )
}
//判定token状态
export function getStatus(){
  return request({
    url:'/api/jump/isJump',
    method:'post'
  })
}




// WEBPACK FOOTER //
// ./src/api/index.js